import { defineMessages } from 'react-intl'

const translations = defineMessages({
  myMachines: {
    defaultMessage: 'My Machines',
    id: 'global.account.link.my_machines'
  },
  placeholderHeading: {
    defaultMessage: `You haven't registered any machine yet.`,
    id: 'msp.account.my_machines.placeholder.no_machines'
  },
  placeholderText: {
    defaultMessage: 'Once you register your machine, it will be visible here.',
    id: 'msp.account.my_machines.placeholder.text'
  },
  placeholderCTAText: {
    defaultMessage: 'Register your machine',
    id: 'msp.account.my_machines.placeholder.cta_text'
  }
})

export default translations
